'use client'

import Script from 'next/script'
import React from 'react'

import FAQ from 'lib/components/FAQ/FAQ'
import NewsletterSignup from 'lib/components/NewsletterSignup/NewsletterSignup'
import Spacer from 'lib/components/Spacer/Spacer'

import NarrativePage from '@/components/NarrativePage'
import { ShipGoWelcomeModal } from '@/components/shipplay/ShipGoWelcomeModal'
import { brand } from '@/utils/brand'

import ShipplayFAQPage from './ShipplayFAQPage'

const FAQpage: React.FC = () => {
  // Ship&Play brand uses the ported playground FAQ page (searchable + topic
  // filter). See ShipplayFAQPage for details.
  if (brand.key === 'shipplay') {
    return (
      <>
        <ShipGoWelcomeModal />
        <ShipplayFAQPage />
      </>
    )
  }

  const { faq, hero, newsletter, structuredData } = brand.pageContent.FAQ

  return (
    <NarrativePage hero={hero}>
      <div className="px-6 lg:px-16">
        <FAQ {...faq} />
      </div>
      <div className="px-6 lg:px-[4.375rem]">
        <NewsletterSignup {...newsletter} />
      </div>
      <Spacer />
      <Script
        id="structured-data"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </NarrativePage>
  )
}

export default FAQpage
